import {createI18n} from 'vue-i18n'
import en from '../lang/en'
import zh from '../lang/zh'

const params = new URLSearchParams(location.search)
const lang = params.get('lang') || 'zh'

if (lang === 'en') {
  localStorage.setItem('accept-language', 'en')
}

const messages = {
  zh: {
    message: zh
  },
  en: {
    message: en
  }
}
  
const i18n = createI18n({
  locale: lang,
  fallbackLocale: 'zh',
  messages
})

export default i18n